import { render, staticRenderFns } from "./InfoRow.vue?vue&type=template&id=044db304&scoped=true"
import script from "./InfoRow.vue?vue&type=script&lang=js"
export * from "./InfoRow.vue?vue&type=script&lang=js"
import style0 from "./InfoRow.vue?vue&type=style&index=0&id=044db304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "044db304",
  null
  
)

export default component.exports